import { jsx } from 'react/jsx-runtime';
import { useResourceUserPinToHomescreen } from '../../../resource-pin/mutations/useMutationResourceUserPin.js';
import { useResourceDataContextSafe } from '../context/resourceDataContext.js';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { IconPin } from '@fabric-app/icons/mobile';

const DropdownItemResourceUserPinHome = () => {
  const { resource } = useResourceDataContextSafe();
  const { togglePin, pinLabel } = useResourceUserPinToHomescreen(resource);
  return /* @__PURE__ */ jsx(DropdownMenu.Item, {
    iconElement: /* @__PURE__ */ jsx(IconPin, {}),
    onClick: togglePin,
    children: pinLabel
  });
};

export { DropdownItemResourceUserPinHome };
//# sourceMappingURL=DropdownItemResourceUserPinHome.js.map
